import MapTableCell from './MapTableCell';

export default MapTableCell;
